/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum LocationCountGroupBy {
  Value0 = 0,
  Value1 = 1,
}

export interface BreakdownLocationAddRequest {
  /** @format int32 */
  id?: number;
  locationId?: string | null;
}

export interface BreakdownLocationResult {
  /** @format int32 */
  id?: number;
  locationId?: string | null;
}

export interface BulkPerformersRequest {
  ids?: string[] | null;
}

export interface CountryResult {
  countryCode?: string | null;
  localisedCountryName?: string | null;
  /** @format int32 */
  index?: number;
  grouping?: string | null;
  states?: StateResult[] | null;
}

export interface CreateLocationRequest {
  id?: string | null;
  countryCode?: string | null;
  administrativeAreaLevel1?: string | null;
  administrativeAreaLevel2?: string | null;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface LocationExtendedResult {
  locationIds?: string[] | null;
}

export interface LocationResult {
  id?: string | null;
  countryCode?: string | null;
  administrativeAreaLevel1?: string | null;
  administrativeAreaLevel2?: string | null;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  country?: string | null;
  isCountry?: boolean;
}

export interface LocationsTreeLevel {
  id?: string | null;
  levelName?: string | null;
  innerLevel?: LocationsTreeLevel[] | null;
}

export interface PerformerLocationAddRequest {
  performerId?: string | null;
  locationId?: string | null;
  /** @format int32 */
  preferenceSortOrder?: number;
}

export interface PerformerLocationCounts {
  /** @format int32 */
  countOfPerformers?: number;
  locationId?: string | null;
  administrativeAreaLevel2?: string | null;
  administrativeAreaLevel1?: string | null;
  countryCode?: string | null;
  countryName?: string | null;
}

export interface PerformerLocationCountsRequest {
  performerIds?: string[] | null;
}

export interface PerformerLocationFilterRequest {
  performerIds?: string[] | null;
  locationIds?: string[] | null;
  adminLevel1s?: string[] | null;
  countryCodes?: string[] | null;
  includeLocationUnspecified?: boolean | null;
}

export interface PerformerLocationResult {
  id?: string | null;
  locationId?: string | null;
  /** @format int32 */
  preferenceSortOrder?: number;
}

export interface PlaceSearchResult {
  id?: string | null;
  placeId?: string | null;
  types?: string[] | null;
  description?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface StateResult {
  id?: string | null;
  stateName?: string | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Spotlight Location API
 * @version v1
 *
 * Spotlight Locations Web API
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  breakdownLocation = {
    /**
     * No description
     *
     * @tags BreakdownLocation
     * @name BreakdownLocationList
     * @request GET:/BreakdownLocation
     */
    breakdownLocationList: <TResponse = LocationResult[], TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/BreakdownLocation`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BreakdownLocation
     * @name BreakdownLocationCreate
     * @request POST:/BreakdownLocation
     */
    breakdownLocationCreate: <
      TResponse = BreakdownLocationResult,
      TError = ProblemDetails,
    >(
      data: BreakdownLocationAddRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/BreakdownLocation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BreakdownLocation
     * @name BreakdownLocationDetail
     * @request GET:/BreakdownLocation/{id}
     */
    breakdownLocationDetail: <
      TResponse = BreakdownLocationResult,
      TError = any,
    >(
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/BreakdownLocation/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BreakdownLocation
     * @name BreakdownLocationDelete
     * @request DELETE:/BreakdownLocation/{id}
     */
    breakdownLocationDelete: <TResponse = unknown, TError = any>(
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/BreakdownLocation/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  debug = {
    /**
     * No description
     *
     * @tags Debug
     * @name DebugList
     * @request GET:/Debug
     */
    debugList: <TResponse = unknown, TError = any>(
      data: {
        searchText?: string;
        placeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Debug`,
        method: "GET",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Debug
     * @name DebugCreate
     * @request POST:/Debug
     */
    debugCreate: <TResponse = unknown, TError = any>(
      data: {
        searchText?: string;
        placeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Debug`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  health = {
    /**
     * No description
     *
     * @tags Health
     * @name HealthList
     * @request GET:/Health
     */
    healthList: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Health`,
        method: "GET",
        ...params,
      }),
  };
  location = {
    /**
     * No description
     *
     * @tags Location
     * @name LocationDetail
     * @request GET:/Location/{id}
     */
    locationDetail: <TResponse = LocationResult, TError = any>(
      id: string,
      query?: {
        langcode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name LocationList
     * @request GET:/Location
     */
    locationList: <TResponse = any[], TError = any>(
      query?: {
        LocationId?: string[];
        LangCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name LocationCreate
     * @request POST:/Location
     */
    locationCreate: <TResponse = unknown, TError = ProblemDetails>(
      data: CreateLocationRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name GoogleDetail
     * @request GET:/Location/google/{placeId}
     */
    googleDetail: <TResponse = LocationResult, TError = any>(
      placeId: string,
      query?: {
        langcode?: string;
        sessionToken?: string;
        preferCities?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location/google/${placeId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name CountryDetail
     * @request GET:/Location/country/{countryCode}
     */
    countryDetail: <TResponse = LocationResult, TError = any>(
      countryCode: string,
      query?: {
        langcode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location/country/${countryCode}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name CountriesList
     * @request GET:/Location/countries
     */
    countriesList: <TResponse = CountryResult[], TError = any>(
      query?: {
        langcode?: string;
        /** @default false */
        inlcludeStates?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location/countries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name CountryStatesList
     * @request GET:/Location/country/{countryCode}/states
     */
    countryStatesList: <TResponse = StateResult[], TError = any>(
      countryCode: string,
      query?: {
        culture?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location/country/${countryCode}/states`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name RendertreeCreate
     * @request POST:/Location/rendertree
     */
    rendertreeCreate: <TResponse = LocationsTreeLevel[], TError = any>(
      data: string[],
      query?: {
        langCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location/rendertree`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Location
     * @name ExtendDetail
     * @request GET:/Location/extend/{id}
     */
    extendDetail: <TResponse = LocationExtendedResult, TError = any>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Location/extend/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  locationSearch = {
    /**
     * No description
     *
     * @tags LocationSearch
     * @name LocationSearchList
     * @request GET:/LocationSearch
     */
    locationSearchList: <TResponse = PlaceSearchResult[], TError = any>(
      query?: {
        searchText?: string;
        langcode?: string;
        types?: string;
        sessionToken?: string;
        location?: string;
        radius?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/LocationSearch`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  performerLocation = {
    /**
     * No description
     *
     * @tags PerformerLocation
     * @name PerformerLocationDetail
     * @request GET:/PerformerLocation/{id}
     */
    performerLocationDetail: <
      TResponse = PerformerLocationResult[],
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerLocation
     * @name BulkCreate
     * @request POST:/PerformerLocation/bulk
     */
    bulkCreate: <TResponse = PerformerLocationResult[], TError = any>(
      data: BulkPerformersRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerLocation
     * @name PerformerLocationList
     * @request GET:/PerformerLocation
     */
    performerLocationList: <TResponse = any[], TError = any>(
      query?: {
        LocationId?: string[];
        IdsOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerLocation
     * @name PerformerLocationCreate
     * @request POST:/PerformerLocation
     */
    performerLocationCreate: <TResponse = unknown, TError = ProblemDetails>(
      data: PerformerLocationAddRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerLocation
     * @name PerformerLocationDelete
     * @request DELETE:/PerformerLocation/{performer_id}/{location_id}
     */
    performerLocationDelete: <TResponse = unknown, TError = any>(
      performerId: string,
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation/${performerId}/${locationId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerLocation
     * @name FilterCreate
     * @request POST:/PerformerLocation/filter
     */
    filterCreate: <TResponse = string[], TError = any>(
      data: PerformerLocationFilterRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation/filter`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerLocation
     * @name CountsbylocationCreate
     * @request POST:/PerformerLocation/countsbylocation
     */
    countsbylocationCreate: <TResponse = PerformerLocationCounts, TError = any>(
      data: PerformerLocationCountsRequest,
      query?: {
        groupBy?: LocationCountGroupBy;
        langcode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation/countsbylocation`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerLocation
     * @name RefreshCreate
     * @request POST:/PerformerLocation/refresh
     */
    refreshCreate: <TResponse = unknown, TError = any>(
      data: PerformerLocationAddRequest[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/PerformerLocation/refresh`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}
